<div class="sel-wrapper" [class.disabled]="isDisabled">
    <ng-container *ngFor="let fl of list">
        <div class="selected-item">
            <span multilang>{{fl.name}}</span>
            <button (click)="this[fl.function](fl.index, fl.field)">
                <mat-icon class="clearbtn">clear</mat-icon>
            </button>
        </div>
    </ng-container>
    <button class="all-remove" *ngIf="list?.length > 0" (click)="resetAll()">Alle Filter löschen</button>
</div>